// extracted by mini-css-extract-plugin
export default {"BidToolHeader":"ViewMaterialAndTruck_BidToolHeader__y700H"};